module.exports = __webpack_public_path__ + "mars-ai-white-eb6bf640.png";